PF.List.Item.Edit = class ItemEdit extends PF.Trait
	{
	initTrait()
		{
		super.initTrait();
		this.dom.load(this.formTemplate, 'form');
		this.calcString('title');
		this.calcString('newTitle');

		this.popup = new PF.F7Popup({
			dom: {
				content: this.dom.form
			},
			title: '',
		});

		this.on('startEdit', (event) => {
			this.popup.open();
		});

		this.popup.on('open', () => {
			if (this.form === undefined)
				{
				this.dom.form.bindObject(this);
				this.form = new PF.Form({
					dom: {element: this.dom.form},
					model: this.model,
					...this.formConfig,
				});
				this.form.once('submit', () => {
					this.popup.close();
					// this.models.list.trigger('add-success', this.model);
				});
				this.form.onValue('fieldsInited', true, () => this.trigger('form-inited'));

				}
		});


		// this.popup = new PF.DynamicPage({
		// 	// path: 'edit',
		// 	dom: {content: this.dom.form},
		// 	title: '',
		// 	template: this.dom.form,
		// 	form: this.form
		// });

		this.popup.calc('title', [
			{object: this, key: 'model.isNewRecord'}, {object: this, key: 'title'}, {object: this, key: 'newTitle'}
		], (n, t, nt) => n === true ? nt : t);


		}
	};